/**
 * Agents hub tab strip: **Agents** (the per-brand card grid) and **Skills**
 * (the agency-level custom-skill catalog). The Skills tab is a management
 * surface (`portal.settings.manage`), so the host decides whether to show it.
 */
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export type AgentsTab = 'agents' | 'skills';

interface Props {
  active: AgentsTab;
  showSkills: boolean;
}

const AgentsTabs = ({ active, showSkills }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const tabs: { key: AgentsTab; label: string; path: string }[] = [
    { key: 'agents', label: t('Agents', 'Agents'), path: '/agents' },
    ...(showSkills
      ? [
          {
            key: 'skills' as AgentsTab,
            label: t('Skills', 'Skills'),
            path: '/agents/skills',
          },
        ]
      : []),
  ];
  if (tabs.length < 2) return null;
  return (
    <nav className='agentsHub__tabs' aria-label={t('AgentsTabsLabel', 'Agents sections')}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type='button'
          className={`agentsHub__tab${
            active === tab.key ? ' agentsHub__tab--active' : ''
          }`}
          aria-current={active === tab.key ? 'page' : undefined}
          onClick={() => {
            if (active !== tab.key) navigate(tab.path);
          }}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
};

export default AgentsTabs;
